module.exports = __webpack_public_path__ + "6aa27045349936f3c670fd71993ca7fe.pdf";